import { $Keys } from 'utility-types'
import {
  ITextEditor_BlockType,
  ITextEditor_BlockData,
  ITextEditor_Link_Target,
  ITextEditor_Link_Target_Self,
  ITextEditor_Link_Target_Blank,
  ITextEditor_Link_Type,
  ITextEditor_Link_Type_Astonish_Open_Browser,
  ITextEditor_Link_Type_Astonish_Unsubscribe,
  ITextEditor_Link_Type_Text,
  ITextEditor_Link_Type_File,
  ITextEditor_Link_Type_Knowledgebase,
  ITextEditor_Link_Type_Group,
  ITextEditor_Link_Type_Group_Text,
  ITextEditor_Link_Type_Group_Astonish,
  ITextEditor_Link_Type_Group_File,
  ITextEditor_Link_Type_Group_Knowledgebase,
  ITextEditor_Link_Type_Group_Settings,
  ITextEditor_HorizontalAlign,
  ITextEditor_HorizontalAlign_Left,
  ITextEditor_HorizontalAlign_Center,
  ITextEditor_HorizontalAlign_Right,
  ITextEditor_Entity_Type_Link,
  ITextEditor_Entity_Type_MagicTag,
} from '../types/texteditor'

import {
  IForm_Color,
} from '../types/schema/form'

export const TEXT_EDITOR_ENTITY_TYPE_LINK: ITextEditor_Entity_Type_Link = 'LINK'
export const TEXT_EDITOR_ENTITY_TYPE_MAGICTAG: ITextEditor_Entity_Type_MagicTag = 'MAGICTAG'

export const TEXT_EDITOR_HORIZONTAL_ALIGN_LEFT: ITextEditor_HorizontalAlign_Left = 'left'
export const TEXT_EDITOR_HORIZONTAL_ALIGN_CENTER: ITextEditor_HorizontalAlign_Center = 'center'
export const TEXT_EDITOR_HORIZONTAL_ALIGN_RIGHT: ITextEditor_HorizontalAlign_Right = 'right'
export const TEXT_EDITOR_HORIZONTAL_ALIGN_DEFAULT: ITextEditor_HorizontalAlign = TEXT_EDITOR_HORIZONTAL_ALIGN_LEFT

export const TEXT_EDITOR_LINK_TYPE_TEXT: ITextEditor_Link_Type_Text = 'text'
export const TEXT_EDITOR_LINK_TYPE_ASTONISH_OPEN_BROWSER: ITextEditor_Link_Type_Astonish_Open_Browser = 'astonish_open_browser'
export const TEXT_EDITOR_LINK_TYPE_ASTONISH_UNSUBSCRIBE: ITextEditor_Link_Type_Astonish_Unsubscribe = 'astonish_unsubscribe'
export const TEXT_EDITOR_LINK_TYPE_FILE: ITextEditor_Link_Type_File = 'file'
export const TEXT_EDITOR_LINK_TYPE_KNOWLEDGEBASE: ITextEditor_Link_Type_Knowledgebase = 'knowledgebase'

export const TEXT_EDITOR_LINK_GROUP_TEXT: ITextEditor_Link_Type_Group_Text = 'text'
export const TEXT_EDITOR_LINK_GROUP_ASTONISH: ITextEditor_Link_Type_Group_Astonish = 'astonish'
export const TEXT_EDITOR_LINK_GROUP_FILE: ITextEditor_Link_Type_Group_File = 'file'
export const TEXT_EDITOR_LINK_GROUP_KNOWLEDGEBASE: ITextEditor_Link_Type_Group_Knowledgebase = 'knowledgebase'
export const TEXT_EDITOR_LINK_GROUP_SETTINGS: ITextEditor_Link_Type_Group_Settings = 'settings'

export const TEXT_EDITOR_LINK_TYPE_GROUPS: Record<ITextEditor_Link_Type, ITextEditor_Link_Type_Group> = {
  [TEXT_EDITOR_LINK_TYPE_TEXT]: TEXT_EDITOR_LINK_GROUP_TEXT,
  [TEXT_EDITOR_LINK_TYPE_ASTONISH_OPEN_BROWSER]: TEXT_EDITOR_LINK_GROUP_ASTONISH,
  [TEXT_EDITOR_LINK_TYPE_ASTONISH_UNSUBSCRIBE]: TEXT_EDITOR_LINK_GROUP_ASTONISH,
  [TEXT_EDITOR_LINK_TYPE_FILE]: TEXT_EDITOR_LINK_GROUP_FILE,
  [TEXT_EDITOR_LINK_TYPE_KNOWLEDGEBASE]: TEXT_EDITOR_LINK_GROUP_KNOWLEDGEBASE,
}

export const TEXT_EDITOR_LINK_GROUP_TITLES: Record<ITextEditor_Link_Type_Group, string> = {
  [TEXT_EDITOR_LINK_GROUP_TEXT]: 'Text Link',
  [TEXT_EDITOR_LINK_GROUP_ASTONISH]: 'Email',
  [TEXT_EDITOR_LINK_GROUP_FILE]: 'File',
  [TEXT_EDITOR_LINK_GROUP_KNOWLEDGEBASE]: 'Knowledgebase',
  [TEXT_EDITOR_LINK_GROUP_SETTINGS]: 'Settings'
}

export const TEXT_EDITOR_LINK_TARGET_SELF: ITextEditor_Link_Target_Self = 'self'
export const TEXT_EDITOR_LINK_TARGET_BLANK: ITextEditor_Link_Target_Blank = 'blank'

export const TEXT_EDITOR_LINK_TARGET_TYPES: {title: string, type: ITextEditor_Link_Target}[] = [{
  title: 'Open in same window',
  type: TEXT_EDITOR_LINK_TARGET_SELF,
}, {
  title: 'Open in new window',
  type: TEXT_EDITOR_LINK_TARGET_BLANK,
}]

export const TEXT_EDITOR_DEFAULT_LINK_TARGET: ITextEditor_Link_Target = TEXT_EDITOR_LINK_TARGET_SELF

export const TEXT_EDITOR_LIST_TYPES = [
  'unordered-list-item',
  'ordered-list-item',
]

export const TEXT_EDITOR_LIST_TAGS = [
  'ol',
  'ul',
]

export const TEXT_EDITOR_TEXT_TYPES: ITextEditor_BlockType[] = [{
  type: 'unstyled',
  title: 'Body Text',
}, {
  type: 'header-one',
  title: 'Header 1',
}, {
  type: 'header-two',
  title: 'Header 2',
}, {
  type: 'header-three',
  title: 'Header 3',
}, {
  type: 'header-four',
  title: 'Header 4',
}, {
  type: 'header-five',
  title: 'Header 5',
}, {
  type: 'header-six',
  title: 'Header 6',
}]

export const TEXT_EDITOR_DEFAULT_COLOR: IForm_Color = {
  color: '#000000',
  shade: 2,
}

export const TEXT_EDITOR_DEFAULT_FONT = 'arial'
export const TEXT_EDITOR_FONTS: ITextEditor_BlockData[] = [{
  title: 'Arial',
  value: 'arial',
},{
  title: 'Courier New',
  value: 'courier',
},{
  title: 'Georgia',
  value: 'georgia',
},{
  title: 'Times New Roman',
  value: 'times',
},{
  title: 'Verdana',
  value: 'verdana',
},{
  title: 'Comic Sans',
  value: 'comic',
},{
  title: 'Tahoma',
  value: 'tahoma',
}]